export const style = {
  button: {
    height: '90px',
    width: '90px',
    borderRadius: '10',
    position: 'absolute',
    bottom: '30px',
    right: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: '100',
    backgroundColor: 'white',
    color: 'gray.600',
    _hover: {
      transition: 'all 200ms ease-in-out',
      backgroundColor: 'gray.100',
      transform: 'translateY(-2px)',
    },
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.1)',
  },
  text: {
    padding: '1',
    textAlign: 'center',
    lineHeight: 'normal',
  },
  icon: {
    boxSize: '10',
    color: 'whatsapp.500',
  },
};
